import { useState } from "react";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { startCheckout, startPix } from "@/lib/billing";
import { PayButtons } from "@/components/app/PayButtons";
import { formatDate } from "@/lib/services";
import { LogoMark } from "@/components/app/Logo";

export default function Paywall() {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const owner = user?.tenant_role === "owner";
  const b = user?.billing || {};

  const pay = async (fn, kind) => {
    setLoading(kind);
    try {
      await fn();
    } catch (err) {
      toast.error(errorMessage(err));
      setLoading(false);
    }
  };

  return (
    <div className="app-grain flex min-h-screen items-center justify-center p-6" data-testid="paywall-page">
      <div className="rise w-full max-w-md rounded-2xl border border-slate-700/60 bg-slate-900 p-8 text-center shadow-2xl">
        <LogoMark className="mx-auto h-12 w-12" />
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight" data-testid="paywall-title">
          {b.status === "trial" && !b.subscribed ? "Seu período grátis terminou" : "Assinatura vencida"}
        </h1>
        <p className="mt-3 text-sm text-slate-400">
          {user?.company_name} · venceu em {formatDate(b.paid_until)}. Seus dados estão guardados e voltam assim que o pagamento for confirmado.
        </p>
        {owner ? (
          <PayButtons prefix="paywall" loading={loading} onCard={() => pay(startCheckout, "card")} onPix={() => pay(startPix, "pix")} />
        ) : (
          <p className="mt-8 rounded-lg border border-slate-700 bg-slate-950 p-3 text-sm text-slate-300" data-testid="paywall-member-message">
            Peça ao responsável da empresa para regularizar a assinatura.
          </p>
        )}
        <Button variant="ghost" onClick={logout} className="mt-3 w-full text-slate-400" data-testid="paywall-logout-button"><LogOut className="mr-2 h-4 w-4" /> Sair</Button>
      </div>
    </div>
  );
}
